import React from 'react';
import { Link } from 'react-router';
import ArticleDetail from '../container/articleDetail';
import Api from '../../ui/src/api.js';
import { getProp } from '../../ui/src/utilities';

class Preview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      parseFail: false,
      article: null,
    };
  }

  componentDidMount() {
    const previewId = getProp(this.props, 'location.query.preview_id', null);
    if (!previewId) {
      this.setState({ parseFail: true, article: null });
    }
    Api.get(`/cm/public/preview/${previewId}`)
      .then(response => {
        this.setState({ parseFail: false, article: response });
      })
      .catch(error => {
        console.error(error);
        this.setState({ parseFail: true, article: null });
      });
  }

  renderFail() {
    return (
      <div className="bg-alt-light">
        <div className="text-center" style={{ padding: '150px 0' }}>
          <h1>Náhľad neexistuje</h1>
          <Link to="/" className="btn btn-primary btn-lg">
            Späť do bezpečia
          </Link>
        </div>
      </div>
    );
  }

  render() {
    if (this.state.parseFail) {
      return this.renderFail();
    }

    return <ArticleDetail article={this.state.article} preview />;
  }
}

export default Preview;



// WEBPACK FOOTER //
// ./src/app/container/preview.js